// extracted by mini-css-extract-plugin
export default {"logo-footer":"Footer_logo-footer__p3Ks-","footer-div":"Footer_footer-div__Eoo9K"};